import Layout from "layout/Layout";
import {
  Login,
  Otp,
  FrontDesk,
  FrontDeskNewBooking,
  FrontDeskAddingEmploye,
  FrontDeskBookingDetails,
  CompanyProfile,
  Billing,
  AboutUs,
  Faq,
  TermAndCondition,
  Help,
  PrivacyPolicy,
  AccountDeletion
} from "./components";

export const routeConfigAuth = [
  { path: "/", component: Login, layout: null, isAuth: false },
  { path: "/login", component: Login, layout: null, isAuth: false },
  { path: "/otp", component: Otp, layout: null, isAuth: false },
  { path: "/about", component: AboutUs, layout: null, isAuth: false },
  { path: "/faq", component: Faq, layout: null, isAuth: false },
  { path: "/termsandcondition", component: TermAndCondition, layout: null, isAuth: false },
  { path: "/help", component: Help, layout: null, isAuth: false },
  { path: "/privacypolicy", component: PrivacyPolicy, layout: null, isAuth: false },
  { path: "/accountSettings", component: AccountDeletion, layout: null, isAuth: false },
];

//FrontDesk Route Config
export const routeConfigFrontDesk = [
  {
    path: "/front-desk/:tabs",
    component: FrontDesk,
    layout: Layout,
    isAuth: true,
  },
  {
    path: "/front-desk/new-booking",
    component: FrontDeskNewBooking,
    layout: Layout,
    isAuth: true,
  },
  {
    path: "/front-desk/new-employee",
    component: FrontDeskAddingEmploye,
    layout: Layout,
    isAuth: true,
  },
  {
    path: "/front-desk/bookingdetails",
    component: FrontDeskBookingDetails,
    layout: Layout,
    isAuth: true,
  },
  {
    path: "/front-desk/companyDetails",
    component: CompanyProfile,
    layout: Layout,
    isAuth: true,
  },
  {
    path: "/front-desk/ProfileDetails",
    component: FrontDeskAddingEmploye,
    layout: Layout,
    isAuth: true,
  },
  { 
    path: "/front-desk/billing/", 
    component: Billing, 
    layout: null, 
    isAuth: true 
  },
];
